import React, { useEffect, useState } from "react";
import PageTitle from "../../components/shared/PageTitle";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../../rules-regulations.css";
export default function RulesRegulation() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useTranslation();

  const [data, setData] = useState(null);
  const locale = useSelector((state) => state.locale.locale);
  useEffect(() => {
    setData(t("raceinfo.rr", { returnObjects: true }));
  }, [t, locale]);

  return (
    <div className="text-white px-4 bg-black 2xl:pb-96 md:pb-96 pb-80">
      <div className="relative">
        <PageTitle
          title={
            locale === "en" ? "Rules & Regulations" : "Peraturan & Ketentuan"
          }
        />
      </div>
      <div className="relative top-80 bg-black 2xl:px-0 md:px-14 px-0">
        <div className="bg-black min-h-screen container mx-auto w-full font-ttFirsNeue text-white">
          <div className="flex items-start justify-start flex-col gap-y-10">
            <p className="text-start md:w-1/2">{t("raceinfo.rrTitle")}</p>
          </div>
          <div className="flex md:flex-row flex-col gap-x-24 mt-10">
            <div className="flex flex-col md:gap-y-10 gap-y-5 mb-10">
              {data?.map((parent, index) => (
                <button
                  key={parent.title}
                  onClick={() => {
                    setCurrentIndex(index);
                    if (window.matchMedia("(min-width: 768px)").matches) {
                      document
                        .getElementById("rules-regulations")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className={`uppercase text-start w-52 text-lg ${
                    currentIndex === index
                      ? "text-white border-b border-b-white font-bold"
                      : "text-neutral-500 font-normal border-none"
                  }`}
                >
                  {parent.title}
                </button>
              ))}
            </div>
            <div>
              <ul
                className="font-light list-decimal px-8 md:px-0 leading-loose md:scroll-m-48 lg:scroll-m-32 xl:scroll-m-48"
                id="rules-regulations"
              >
                {data?.[currentIndex]?.data?.map((item) => (
                  <li
                    key={item.id}
                    className="mb-2"
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  ></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
